import { useEffect } from 'react';
import { useStoreState } from '@/stores/store';
import { getUser } from '@/api/services/user';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { logError } from '@/utils/logHandling';

import { PatientStackParamList } from '@/navigations/PatientStack';
import { TherapistStackParamList } from '@/navigations/TherapistStack';

export const useMarketingChannelRedirect = () => {
  const { isTherapistDemo, isPatientDemo } = useStoreState((state) => state);
  const { navigate } =
    useNavigation<
      StackNavigationProp<TherapistStackParamList | PatientStackParamList>
    >();

  useEffect(() => {
    const determineInitialRoute = async () => {
      try {
        const isDemoMode = isTherapistDemo || isPatientDemo;
        if (isDemoMode) {
          return;
        }
        const user = await getUser();

        if (user.marketingChannelSelection === null) {
          navigate('MarketingChannelQuestionnaire');
        }
      } catch (error) {
        logError('Error fetching user for marketing channel redirect', error);
      }
    };

    determineInitialRoute();
  }, []);
};
